/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-12 17:52:44
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-13 10:02:17
 */
const context = import.meta.glob('./common/**/**/index.js', { eager: true })
export default context
